<template>
    <div>
        <national-trademark-renewals-form :getNationalTrademarkList="getNationalTrademarkList" :getNationalTrademarkRenewalsList="getNationalTrademarkRenewalsList" ref="nationalTrademarkRenewalsFormModal"></national-trademark-renewals-form>
        <b-row>
          <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <b-button style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)"
                    >{{ $t('nationalTrademarkRenewals.add') }}</b-button>
                </div>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table 
        id="nationalTrademarkRenewalsTable"
        ref="nationalTrademarkRenewalsTable" 
        :columns="columns" 
        :rows="rows"
        styleClass="vgt-table condensed tableSize"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" 
          theme="my-theme">
          <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
          </div>
          <!-- Row: Table Row -->
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'renewalDate'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.renewal_date') }}
            </span>
            <span v-else-if="props.column.field === 'instructionDate'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.instruction_date') }}
            </span>
            <span v-else-if="props.column.field === 'reminderDate'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.reminder_date') }}
            </span>
            <span v-else-if="props.column.field === 'nextRenewalDate'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.next_renewal_date') }}
            </span>
            <span v-else-if="props.column.field === 'agent'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.agent')}}
            </span>
            <span v-else-if="props.column.field === 'agentReferenceNo'" class="text-nowrap">
              {{ $t('nationalTrademarkRenewals.agent_reference_no')}}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
              {{ $t('others.process') }}
            </span>
          </template>
          <!-- Column: Table Column -->
          <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
              <span>
                <b-button v-b-tooltip.html :title="$t('others.edit')" variant="primary" class="btn-icon mb-1 ml-1"
                  size="sm" @click="getInfo(props.row.id)">
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                  size="sm" @click="deleted(props.row)">
                  <feather-icon icon="XIcon" />
                </b-button>
              </span>
            </span>
          </template>
        </vue-good-table>
    </div>
</template>
<script>
export default {
    props: {
        nationalTrademarkId: Number,
        getNationalTrademarkList: {
            type: Function
        },
    },
    data() {
        return {
            dir: false,
            columns: [
            {
                label: this.$t('nationalTrademarkRenewals.renewal_date'),
                field: `renewalDate`,
                formatFn: this.$formatFn
            },
            {
                label: this.$t('nationalTrademarkRenewals.instruction_date'),
                field: `instructionDate`,
                formatFn: this.$formatFn
            },
            {
                label: this.$t('nationalTrademarkRenewals.reminder_date'),
                field: `reminderDate`,
                formatFn: this.$formatFn
            },
            {
                label: this.$t('nationalTrademarkRenewals.next_renewal_date'),
                field: `nextRenewalDate`,
                formatFn: this.$formatFn
            },
            {
                label: this.$t('nationalTrademarkRenewals.agent_ref_no'),
                field: `agentReferenceNo`,
            },
            {
                label: this.$t('nationalTrademarkRenewals.agent'),
                field: `agent`,
            },
            {
                label: 'Process',
                field: 'process',
                width: '10em'
            },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted(){
        this.getNationalTrademarkRenewalsList()
    },
    methods: {
        async deleted(data) {
            data = { id: data.id }
            const controller = { name: 'NationalTrademarkRenewal' }
            const payload = { data: data, controller: controller }
            this.$DeleteConfirm().then(result => {
            if (result.value) {
                this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$DeleteAlert()
                    this.getNationalTrademarkRenewalsList()
                    this.getNationalTrademarkList()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.getNationalTrademarkRenewalsList()
                }
                })
            }
            })
        },
        async getInfo(id) {
          this.$refs.nationalTrademarkRenewalsFormModal.showInfo(id, this.nationalTrademarkId)
        },
        getNationalTrademarkRenewalsList() {
            this.rows = [] 
            const data = { id: this.nationalTrademarkId }
            const controller = { name: 'NationalTrademarkRenewal', actionName:'GetNationalTrademarkRenewalListByNationalTrademarkId' }
            const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
            if (response.data.resultStatus == true) {
                response.data.nationalTrademarkRenewalList.forEach(element => {
                this.rows.push(element)
                })
            }
            else {
                this.$WarningAlert(response.data.resultMessage)
            }
            }
            )
        },
    }
}
</script>
<style lang="scss" >
.tableSize {
  font-size: 13px!important;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  table-layout: auto;
}
</style>